<template>
  <div id="app" v-loading="pageLoading">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "App",
  computed:{
    pageLoading() {
      return this.$store.state.app.pageLoading.pageLoadingStatus;
    }
  }
};
</script>

<style scoped lang="scss">
.el-input__inner {
  width: 100% !important;
}
/* html,
body {
  min-width: 1280px;
  overflow-x: hidden;
} */
/deep/.el-top-nav-menu4 .sub-menu-wrapper-wrapper .sub-menu-wrapper .logo-container img{
  width: 120px;
  height: auto;
}
</style>
